export default {
    sidebar: {
        open: window.innerWidth > 1024,
    }
}